<template>
  <div class="app flex-row auth-page">
    <div class="container-fluid">

      <b-row>
        <b-col md="7" class="auth-hero-column d-none d-md-block">
          <BrandLoginHero />
        </b-col>

        <b-col md="5" class="auth-panel-column">
          <main class="auth-panel">
            <div class="auth-brand">
              <BrandLoginHero compact />
            </div>

            <b-card no-body class="auth-card">
              <b-card-body class="auth-card-body">
                <div v-if="hasCustomerBrand" class="auth-customer-brand">
                  <span class="auth-customer-brand__label">Espacio de trabajo</span>
                  <CustomerBrandLogo variant="full" context="auth" :alt="customerName" />
                </div>

                <b-form class="auth-form" @submit.prevent="login">
                  <div class="auth-heading">
                    <div class="auth-panel-header">
                      <AppIcon name="lock" />
                      <span class="auth-panel-title">Acceder</span>
                    </div>
                    <p>Ingresá a tu espacio de trabajo para continuar.</p>
                  </div>

                  <b-form-group label="Correo electrónico" class="auth-field">
                    <b-input-group class="auth-input-group">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <AppIcon name="person" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="email" class="form-control" placeholder="tu@email.com" autocomplete="email" v-model="form.email"/>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group label="Contraseña" class="auth-field">
                    <b-input-group class="auth-input-group">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <AppIcon name="lock" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="password" class="form-control" placeholder="Ingresá tu contraseña" autocomplete="current-password" v-model="form.password"/>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group label="Base de datos" class="auth-field" v-if="parameters.databaseSwitcher && databaseSwitcher.configured">
                    <b-form-select class="auth-select" v-model="form.database_key" :options="databaseSwitcher.options"></b-form-select>
                  </b-form-group>

                  <b-alert show variant="warning" class="auth-database-alert" v-if="parameters.databaseSwitcher && databaseSwitcher.message">
                    {{ databaseSwitcher.message }}
                  </b-alert>

                  <b-button type="submit" variant="primary" class="auth-submit primary-background">
                    <AppIcon name="arrow_forward" class="mr-2" /> ACCEDER
                  </b-button>

                  <div class="auth-actions">
                    <b-button variant="link" class="auth-link" @click="ir('recovery')">
                      <AppIcon name="key" /> Olvidé mi contraseña
                    </b-button>
                    <b-button variant="link" class="auth-link" @click="ir('register')" v-if="parameters.registersUser">
                      <AppIcon name="person_add" /> Crear usuario
                    </b-button>
                  </div>

                  <div class="auth-offline-status" v-if="!isOnline">
                    <AppIcon name="wifi_off" /> Sin conexión: algunas funciones pueden no estar disponibles.
                  </div>
                </b-form>
              </b-card-body>
            </b-card>

            <div v-if="parameters.showClearCacheButton" class="auth-cache-wrap">
              <button type="button" class="auth-cache-link" @click="clearCache">
                <AppIcon name="delete" font-scale="0.85" /> Borrar caché
              </button>
            </div>
          </main>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import serviceAPI from './services'
  import {EventBus} from '@/handler/event-bus'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import Profiles from '@/config/profiles'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import BrandLoginHero from '@/components/branding/BrandLoginHero'
  import Branding from '@/components/branding/branding'
  import CustomerBrandLogo from '@/components/branding/CustomerBrandLogo'

  export default {
    components: {
      BrandLoginHero,
      CustomerBrandLogo,
    },
    data () {
      return {
        isOnline: navigator.onLine,
        form: {
          email: '',
          password: '',
          database_key: null,
        },
        databaseSwitcher: {
          configured: false,
          options: [],
          message: '',
        },
        brandingVersion: 0,
        parameters: {
          registersUser: Helper.hasParametersAccess(Param.P1),
          showClearCacheButton: Helper.hasParametersAccess(Param.P74),
          databaseSwitcher: Helper.hasParametersAccess(Param.P78)
        }
      }
    },
    computed: {
      customerName() {
        const session = Session.getSession()
        return session && session.settings
          ? session.settings.proyect_name || 'Empresa'
          : 'Empresa'
      },
      hasCustomerBrand() {
        this.brandingVersion
        const session = Session.getSession()
        const branding = Branding.resolve(session && session.settings)
        return (branding.logoCustomized && branding.logo) ||
               (branding.iconCustomized && branding.icon)
      },
    },
    created () {
      EventBus.$on('Parameters:parameters', () => {
        this.setupParameters()
      })
      EventBus.$on('Settings:settings', this.refreshBranding)
    },
    beforeDestroy() {
      EventBus.$off('Settings:settings', this.refreshBranding)
    },
    mounted() {
      this.setupParameters()
      this.loadParameters()
      window.addEventListener('online', () => { this.isOnline = true })
      window.addEventListener('offline', () => { this.isOnline = false })
    },
    methods: {
      refreshBranding() {
        this.brandingVersion++
      },
      setupParameters () {
        if(Session.getSession().parameters) {
          this.parameters.registersUser = Helper.hasParametersAccess(Param.P1)
          this.parameters.showClearCacheButton = Helper.hasParametersAccess(Param.P74)
          this.parameters.databaseSwitcher = Helper.hasParametersAccess(Param.P78)

          if(this.parameters.databaseSwitcher) {
            this.loadDatabaseSwitcher()
          } else {
            this.databaseSwitcher.configured = false
            this.databaseSwitcher.options = []
            this.databaseSwitcher.message = ''
            this.form.database_key = null
          }
        }
      },
      loadParameters() {
        let loader = this.$loading.show()
        var result = serviceAPI.obtenerParametros()

        result.then((response) => {
          var data = response.data

          Session.setSessionParameters(data);
          loader.hide()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
          loader.hide()
        });
      },
      loadDatabaseSwitcher() {
        serviceAPI
          .obtenerDatabaseSwitcher()
          .then((response) => {
            var data = response.data

            if(!data.enabled) {
              this.databaseSwitcher.configured = false
              this.databaseSwitcher.options = []
              this.databaseSwitcher.message = ''
              this.form.database_key = null
              return
            }

            if(!data.status || !data.configured) {
              this.databaseSwitcher.configured = false
              this.databaseSwitcher.options = []
              this.databaseSwitcher.message = data.message
              this.form.database_key = null
              return
            }

            this.databaseSwitcher.configured = true
            this.databaseSwitcher.message = ''
            this.databaseSwitcher.options = data.databases.map((item) => {
              return {
                value: item.key,
                text: item.current ? item.label + ' (actual)' : item.label
              }
            })
            this.form.database_key = data.current_key || (this.databaseSwitcher.options[0] ? this.databaseSwitcher.options[0].value : null)
          })
          .catch(error => {
            this.databaseSwitcher.configured = false
            this.databaseSwitcher.options = []
            this.databaseSwitcher.message = Error.showError(error)
            this.form.database_key = null
          });
      },
      ir(path) {
        if(path == 'register') {
          this.$router.push({ name: 'Register' })
        }
        if(path == 'recovery') {
          this.$router.push({ name: 'Recovery' })
        }
      },
      clearCache () {
        this.$router.push({ path: '/auth/clear' })
      },
      async login () {
        let loader = this.$loading.show()
        await serviceAPI
          .login(this.form)
          .then(async (response) => {
            var data = response.data          

            Session.setSessionAuth(data);

            await serviceAPI
              .obtenerParametros()
              .then((response) => {
                Session.setSessionParameters(response.data);
              })

            // La preferencia es por usuario y define la ruta de entrada. Se
            // consulta antes de navegar al contenedor para que el guard no
            // decida con un valor viejo (o el valor por defecto) del storage.
            if (data.user.profile_id == Profiles.PERSONAL && Session.hasMySpaceModeAvailable()) {
              await serviceAPI.getUserPreference('my_space_mode')
                .then((response) => {
                  var mode = response.data && response.data.value
                  if (mode === 'legacy' || mode === 'modern') Session.setMySpaceModePreference(mode)
                })
                .catch(() => {})
            }

            StorageLocal.removeValue('configWidget');
            await serviceAPI
              .obtenerWidget()
              .then((response) => {            
                StorageLocal.setValue('configWidget', JSON.stringify(response.data));
              })

            StorageLocal.removeValue('configWidgetEmployee');
            if (data.user.profile_id == Profiles.PERSONAL) {
              await serviceAPI
                .obtenerEmpleado()
                .then((response) => {
                  StorageLocal.setValue('configWidgetEmployee', JSON.stringify(response.data));
                })
            }

            // suscribe a las notificaciones
            Storage.removeValue('NotificationsSentToServer')
            try {
              require("../../handler/notifications.js")   
            } catch (error) {
              console.log("PWA Notifications disable")
            }          

            // El guard IS_AUTENTICADO de esta ruta redirige a next({name: ...})
            // según el perfil (ver router/permisos.js); eso rechaza la promesa
            // de este push con un "Redirected via a navigation guard", que es
            // el comportamiento esperado de vue-router y no un error real.
            this.$router.push({ name: 'Contenedor' }).catch(() => {})
            loader.hide()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
            loader.hide()
          });
      }
    },
  }
</script>

<style src="./auth.css"></style>
